var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_NewCustomerApplication"),
        width: _vm.$selectByLang("850px", "850px", "950px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "customer-application-form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": _vm.$selectByLang("140px", "140px", "180px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.partner.cnShortName"),
                        prop: "cnShortName"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "cnShortName",
                          maxlength: 64,
                          disabled: true
                        },
                        model: {
                          value: _vm.form.cnShortName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cnShortName", $$v)
                          },
                          expression: "form.cnShortName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_DomesticOverseas"),
                        prop: "oversea"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { no: "oversea" },
                          model: {
                            value: _vm.form.oversea,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "oversea", $$v)
                            },
                            expression: "form.oversea"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Domestic"),
                              value: false
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_International"),
                              value: true
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ChineseNamed"),
                        prop: "chineseName"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "chineseName", maxlength: 200 },
                        model: {
                          value: _vm.form.chineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "chineseName", $$v)
                          },
                          expression: "form.chineseName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.partner.shortName"),
                        prop: "shortName"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "shortName", maxlength: 100 },
                        model: {
                          value: _vm.form.shortName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "shortName", $$v)
                          },
                          expression: "form.shortName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.partner.englishName"),
                        prop: "englishName"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "englishName", maxlength: 200 },
                        model: {
                          value: _vm.form.englishName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "englishName", $$v)
                          },
                          expression: "form.englishName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "CargoMsg.Cargo_IncludeOverseasWarehouse"
                        ),
                        prop: "overseasWarehouse"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { no: "overseasWarehouse" },
                          model: {
                            value: _vm.form.overseasWarehouse,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "overseasWarehouse", $$v)
                            },
                            expression: "form.overseasWarehouse"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("Message.Yes"), value: true }
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("Message.No"), value: false }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Partners.isPeers"), prop: "peer" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { no: "peer" },
                          model: {
                            value: _vm.form.peer,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "peer", $$v)
                            },
                            expression: "form.peer"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("Message.Yes"), value: true }
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("Message.No"), value: false }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomerLevel"),
                        prop: "customerTypeId"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.form.customerTypeId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "customerTypeId", $$v)
                            },
                            expression: "form.customerTypeId"
                          }
                        },
                        _vm._l(_vm.customerTypeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.chineseName,
                              value: item.typeId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.Addr"),
                        prop: "address"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "address", maxlength: 500 },
                        model: {
                          value: _vm.form.address,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "address", $$v)
                          },
                          expression: "form.address"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_TradeType"),
                        prop: "tradeTypes"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          "callback-method-type": "value",
                          multiple: true,
                          "default-multiple-value": _vm.toArray(
                            _vm.form.tradeTypes
                          ),
                          "callback-params": { key: "tradeTypes" }
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.tradeTypes = _vm.toTxt(p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Partners.accountPeriod"),
                        prop: "creditDateLimited"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          "default-value": _vm.form.creditDateLimited,
                          clearable: false,
                          "tag-name": "name",
                          "tag-value": "code",
                          "static-options": _vm.creditDateLimitedList
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.creditDateLimited = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Partners.limit"), prop: "credit" }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, controls: false },
                        model: {
                          value: _vm.form.credit,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "credit", $$v)
                          },
                          expression: "form.credit"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_SignContract2"),
                        prop: "signContract"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { no: "signContract" },
                          model: {
                            value: _vm.form.signContract,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "signContract", $$v)
                            },
                            expression: "form.signContract"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("Message.Yes"), value: true }
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("Message.No"), value: false }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_LatestContractDate"),
                        prop: "latestContractDate"
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                        model: {
                          value: _vm.form.latestContractDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "latestContractDate", $$v)
                          },
                          expression: "form.latestContractDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_RuleRole") } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { disabled: true, no: "roleCustomer" },
                  model: {
                    value: _vm.form.customer,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "customer", $$v)
                    },
                    expression: "form.customer"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Partners.customer")) + " ")]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("Partners.relatedBusinessType"),
                prop: "relatedBusinessTypes"
              }
            },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "seaExport" },
                  model: {
                    value: _vm.form.seaExport,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "seaExport", $$v)
                    },
                    expression: "form.seaExport"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("constant.systemConstants.SE")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "seaImport" },
                  model: {
                    value: _vm.form.seaImport,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "seaImport", $$v)
                    },
                    expression: "form.seaImport"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("constant.systemConstants.SI")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "airExport" },
                  model: {
                    value: _vm.form.airExport,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "airExport", $$v)
                    },
                    expression: "form.airExport"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("constant.systemConstants.AE")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "airImport" },
                  model: {
                    value: _vm.form.airImport,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "airImport", $$v)
                    },
                    expression: "form.airImport"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("constant.systemConstants.AI")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "railwayExport" },
                  model: {
                    value: _vm.form.railwayExport,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "railwayExport", $$v)
                    },
                    expression: "form.railwayExport"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("constant.systemConstants.RB")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "integratedJob" },
                  model: {
                    value: _vm.form.integratedJob,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "integratedJob", $$v)
                    },
                    expression: "form.integratedJob"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("constant.systemConstants.IE")))]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("Partners.theCorrespondingServicePartners")
              }
            },
            [
              _c(
                "div",
                { staticStyle: { height: "240px" } },
                [
                  _c("company-user-container", {
                    ref: "companyUserContainer",
                    attrs: { action: "edit" }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_CreditControlSelfAssessment"),
                prop: "creditSelfAssessment"
              }
            },
            [
              _c(
                "div",
                { staticClass: "upload-file-row" },
                [
                  _vm.hasUploadedFile("creditSelfAssessment")
                    ? [
                        _c("span", { staticClass: "upload-file-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getUploadedFileName("creditSelfAssessment")
                            )
                          )
                        ]),
                        _c("el-button", {
                          staticClass: "upload-file-remove",
                          attrs: { type: "text", icon: "el-icon-close" },
                          on: {
                            click: function($event) {
                              return _vm.handleRemoveUpload(
                                "creditSelfAssessment"
                              )
                            }
                          }
                        })
                      ]
                    : _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.handleUpload("creditSelfAssessment")
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Upload")) + " "
                          )
                        ]
                      )
                ],
                2
              )
            ]
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_CustomerFile"),
                prop: "customerProfile"
              }
            },
            [
              _c(
                "div",
                { staticClass: "upload-file-row" },
                [
                  _vm.hasUploadedFile("customerProfile")
                    ? [
                        _c("span", { staticClass: "upload-file-name" }, [
                          _vm._v(
                            _vm._s(_vm.getUploadedFileName("customerProfile"))
                          )
                        ]),
                        _c("el-button", {
                          staticClass: "upload-file-remove",
                          attrs: { type: "text", icon: "el-icon-close" },
                          on: {
                            click: function($event) {
                              return _vm.handleRemoveUpload("customerProfile")
                            }
                          }
                        })
                      ]
                    : _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.handleUpload("customerProfile")
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Upload")) + " "
                          )
                        ]
                      )
                ],
                2
              )
            ]
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_CustomerConsignmentNote"),
                prop: "customerCommission"
              }
            },
            [
              _c(
                "div",
                { staticClass: "upload-file-row" },
                [
                  _vm.hasUploadedFile("customerCommission")
                    ? [
                        _c("span", { staticClass: "upload-file-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getUploadedFileName("customerCommission")
                            )
                          )
                        ]),
                        _c("el-button", {
                          staticClass: "upload-file-remove",
                          attrs: { type: "text", icon: "el-icon-close" },
                          on: {
                            click: function($event) {
                              return _vm.handleRemoveUpload(
                                "customerCommission"
                              )
                            }
                          }
                        })
                      ]
                    : _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.handleUpload("customerCommission")
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Upload")) + " "
                          )
                        ]
                      )
                ],
                2
              )
            ]
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Application_Reason"),
                prop: "applicationReason"
              }
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  maxlength: 500,
                  "show-word-limit": "",
                  no: "applicationReason"
                },
                model: {
                  value: _vm.form.applicationReason,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "applicationReason", $$v)
                  },
                  expression: "form.applicationReason"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "submit" },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      ),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.cloudFile.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: _vm.uploadSuccess
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }